export const CHAT_MESSAGES_PATH = "/app/messages";
export const CHAT_MESSAGE_QUERY_PARAM = "messageId";

export function buildChatPath(chatId:number|string, messageId?:number|string|null):string {
  const targetMessageId = parsePositiveInteger(messageId);
  const basePath = `${CHAT_MESSAGES_PATH}/${chatId}`;

  if (targetMessageId === undefined) {
    return basePath;
  }

  return `${basePath}?${CHAT_MESSAGE_QUERY_PARAM}=${targetMessageId}`;
}

export function getChatTargetMessageId(search:string):number|undefined {
  const queryString = search.charAt(0) === "?" ? search.substring(1) : search;
  if (queryString.length === 0) {
    return undefined;
  }

  const params = queryString.split("&");
  for (const param of params) {
    const separatorIndex = param.indexOf("=");
    const rawKey = separatorIndex === -1 ? param : param.substring(0, separatorIndex);
    const rawValue = separatorIndex === -1 ? "" : param.substring(separatorIndex + 1);
    const key = decodeQueryValue(rawKey);

    if (key === CHAT_MESSAGE_QUERY_PARAM) {
      return parsePositiveInteger(decodeQueryValue(rawValue));
    }
  }

  return undefined;
}

export function parsePositiveInteger(value:number|string|null|undefined):number|undefined {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  const parsed = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0 || Math.floor(parsed) !== parsed) {
    return undefined;
  }

  return parsed;
}

function decodeQueryValue(value:string):string {
  try {
    return decodeURIComponent(value.replace(/\+/g, " "));
  } catch (error) {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/router/chatRoute.ts